export const fileDownloader = {
	selector: {
		button: '.js-download-file',
	},
	attribute: {
		url: 'data-download-url',
	},
	regex: {
		filename: /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
	},
}
